
import { useState, useEffect } from "react";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { Footer } from "./Footer";
import Navheader from "./Navheader";
import { Toaster } from "sonner";

const Layout = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [scriptsLoaded, setScriptsLoaded] = useState(false);

  useEffect(() => {
    // Vérifier si ApexCharts et Peity sont disponibles
    const checkScripts = () => {
      if (window.ApexCharts && window.$ && window.$.fn.peity) {
        setScriptsLoaded(true);
      }
    };

    // Attendre que tous les scripts soient chargés
    const timer = setTimeout(() => {
      setIsLoading(false);
      checkScripts();
    }, 1000);

    // Vérifier périodiquement
    const interval = setInterval(checkScripts, 500);

    return () => {
      clearTimeout(timer);
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    // Code jQuery existant pour Chatbox & attachments
    if (window.$ && scriptsLoaded) {
      window.$(".chat-toggle").on("click", () => {
        window.$(".chat-left-area, .chat-toggle").toggleClass("active");
      });
      window.$("#attachButton").click(() => window.$("#attachmentInput").trigger("click"));
      window.$("#attachmentInput").change(function () {
        const files = this.files;
        let list = "";
        for (let i = 0; i < files.length; i++) {
          list += `<div>${files[i].name}</div>`;
        }
        window.$("#attachedFiles").html(list);
      });

      // Initialiser les graphiques si nécessaires
      if (window.pieChart && typeof window.pieChart === 'function') {
        try {
          window.pieChart();
        } catch (error) {
          // console.warn('Erreur lors de l\'initialisation de pieChart:', error);
        }
      }

      if (window.donutChart2 && typeof window.donutChart2 === 'function') {
        try {
          window.donutChart2();
        } catch (error) {
          // console.warn('Erreur lors de l\'initialisation de donutChart2:', error);
        }
      }
    }
  }, [scriptsLoaded]);

  return (
    <>
      {isLoading ? (
        <div
          className="d-flex flex-column align-items-center justify-content-center vh-100 bg-white"
          style={{ gap: "1.5rem", zIndex: 1050 }}
        >
          <div
            className="spinner-border text-primary"
            role="status"
            style={{ width: "4rem", height: "4rem" }}
          >
            <span className="visually-hidden text-center fs-3">Veuillez patienter...</span>
          </div>
          <img
            src="https://cdn.prod.website-files.com/68063d6193c1f009cf1fdccd/6806b7b5df7ca03c524c1008_Projet%20Studio%20(1).png"
            alt="Tradevault Logo"
            className="img-fluid"
            style={{ maxWidth: "350px" }}
          />
        </div>
      ) : (
        <div id="main-wrapper" className="show romeo">
          <Navheader />
          <Header />
          <Sidebar />
          <Toaster position="top-center" richColors expand={true} />
          {children}
          <Footer />
        </div>
      )}
    </>
  );
};

export default Layout;